import { connect } from 'react-redux';
import Files, { IFilesStateProps } from '../components/files/Files';
import { IApplicationState } from '@store';

interface IMapStateToProps extends Pick<IApplicationState, 'files'> {}

const mapStateToProps = ({ files }: IMapStateToProps): IFilesStateProps => {
  return {
    files: files.files,
    requestStatus: files.status,
  };
};

export default connect(mapStateToProps)(Files);
